var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boilerplate"},[_c('v-row',[_c('v-col',[_c('h3',{staticClass:"mb-3"},[_vm._v(" "+_vm._s(_vm.$t('P2P roles'))+" ")]),_c('P2PArbitratorsList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }